export type DocTypeValue = string | null | undefined

/** Human-readable document type for list views and collapsed metadata. */
export function docTypeLabel(docType: DocTypeValue): string {
  switch (docType) {
    case 'bill':
      return 'Bill'
    case 'vendor_credit':
      return 'Vendor credit'
    case 'card_expense':
      return 'Card expense'
    case 'card_credit':
      return 'Card credit'
    default:
      return 'Credit'
  }
}

export function docTypeRequiresLineItems(docType: DocTypeValue): boolean {
  return (
    docType === 'bill' ||
    docType === 'vendor_credit' ||
    docType === 'card_expense' ||
    docType === 'card_credit'
  )
}

export function isCardDocType(docType: DocTypeValue): boolean {
  return docType === 'card_expense' || docType === 'card_credit'
}
